import { render, staticRenderFns } from "./DailyVolumePrediction.vue?vue&type=template&id=0b9dec46&scoped=true&"
import script from "./DailyVolumePrediction.vue?vue&type=script&lang=ts&"
export * from "./DailyVolumePrediction.vue?vue&type=script&lang=ts&"
import style0 from "./DailyVolumePrediction.vue?vue&type=style&index=0&id=0b9dec46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9dec46",
  null
  
)

export default component.exports